function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9167 27.6665V11.6248L36.6667 19.6732L22.9167 27.6665ZM54.45 8.57005C54.45 8.57005 53.9115 4.75442 52.2638 3.07234C50.1715 0.865462 47.8271 0.856295 46.7523 0.727962C39.0569 0.166503 27.5115 0.166504 27.5115 0.166504H27.4885C27.4885 0.166504 15.9431 0.166503 8.24771 0.727962C7.17062 0.856295 4.82854 0.865462 2.73396 3.07234C1.08625 4.75442 0.55 8.57234 0.55 8.57234C0.55 8.57234 0 13.0503 0 17.5305V21.7357C0 26.2182 0.55 30.7007 0.55 30.7007C0.55 30.7007 1.08625 34.5163 2.73396 36.1984C4.82854 38.4053 7.57625 38.3342 8.8 38.5657C13.2 38.9942 27.5 39.1248 27.5 39.1248C27.5 39.1248 39.0569 39.1065 46.7523 38.5473C47.8294 38.4167 50.1715 38.4075 52.2638 36.2007C53.9137 34.5186 54.45 30.7007 54.45 30.7007C54.45 30.7007 55 26.2205 55 21.738V17.535C55 13.0525 54.45 8.57005 54.45 8.57005Z",
  fill: "#FF0000"
});

function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 40,
    viewBox: "0 0 55 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.3dc45c80.svg";
export { ForwardRef as ReactComponent };